import { ref, onMounted, defineComponent } from 'vue';

/**
 * @description Component to be rendered only on a client side
 *
 * It can be used we need to render a component only on a client because it uses BrowserAPI
 * or if we need to postpone render of some heavy components
 *
 * @see https://vite-plugin-ssr.com/client-only-components - VPS docs
 * @see https://github.com/vikejs/vike/issues/278#issuecomment-1072952681 - implementation
 *
 * PS: Need to check if ClientOnly optimizes the load of heavy components. Maybe replace it after migration to Vike
 *
 * @see https://vike.dev/ClientOnly
 */
export const ClientOnly = defineComponent({
  setup(_, { slots }) {
    const show = ref(false);
    onMounted(() => {
      show.value = true;
    });
    return () => (show.value && slots.default ? slots.default() : null);
  },
});
